

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATNEWSLETER= createAsyncThunk(
  "updateNewsletter/updateNewsletter",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateNewsletterSlice = createSlice({
  name: "updateNewsletterSlice",
  initialState: {
    updateNewsletter: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateNewsletter: (state) => {
        state.updateNewsletter.loading = false
        state.updateNewsletter.error = false
        state.updateNewsletter.data = []
        state.updateNewsletter.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATNEWSLETER.fulfilled, (state, action) => {
      state.updateNewsletter = {
        ...state.updateNewsletter,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATNEWSLETER.pending, (state, action) => {
      state.updateNewsletter = {
        ...state.updateNewsletter,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATNEWSLETER.rejected, (state, action) => {
      state.updateNewsletter = {
        ...state.updateNewsletter,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateNewsletterAction = {
    UPDATNEWSLETER,
};

export { updateNewsletterAction };
export default updateNewsletterSlice.reducer;
export const {setInitialStateOfupdateNewsletter} = updateNewsletterSlice.actions
